export default "__VITE_ASSET__771694e5__"